export enum WhenWillNotified {
  sendEachSignature = 1,
  sendCompletedEnvelope = 2,
}
